import React from 'react';
/**
 * @deprecated utiliser `SelectControl` ou `Select`. Sera supprimé dans une futur Release d'ici fin 2025.
 */
var Option = function (_a) {
    var value = _a.value, children = _a.children, selected = _a.selected, disabled = _a.disabled, hidden = _a.hidden;
    return (React.createElement("option", { value: value, selected: selected, disabled: disabled, hidden: hidden }, children));
};
export default Option;
